import styled from 'styled-components';

import { IFeature, IGlassesPackage } from '../../types';
import { BaseCheck } from '../../svg/Check';
import { breakpoints, colors, spacing } from '../../constants';

interface IFeatureProps {
    displayBold: boolean;
    isActive: boolean;
}

export const Feature = styled.li<IFeatureProps>`
    padding: 5px 0;
    color: ${(props) =>
        props.isActive ? colors.black : colors.transparentBlack};
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: ${({ displayBold }) => displayBold && 700};

    a {
        color: ${(props) =>
            props.isActive ? colors.black : colors.transparentBlack};
    }

    @media (${breakpoints.mediumMin}) {
        font-size: 16px;
    }
`;

const Check = styled(BaseCheck)`
    width: 16px;
    height: 16px;
    stroke: ${colors.black};
    margin-right: 10px;
`;

const CheckHolder = styled.div`
    width: 26px;
`;

interface IProps {
    allFeatures: IFeature[];
    glassesPackage: IGlassesPackage;
    className?: string;
}

const BaseFeatureList = ({
    allFeatures,
    glassesPackage: { featureIds },
    className,
}: IProps) => (
    <ul className={className}>
        {[...allFeatures]
            .sort((a, b) => a.order - b.order)
            .map((feature) => {
                const isActive = featureIds.includes(feature.id);

                return (
                    <Feature
                        displayBold={feature.displayBold}
                        isActive={isActive}
                        key={feature.id}
                    >
                        <CheckHolder>{isActive && <Check />}</CheckHolder>
                        {feature.url && isActive ? (
                            <a
                                href={feature.url}
                                rel="noreferrer"
                                target="_blank"
                            >
                                {feature.name}
                            </a>
                        ) : (
                            feature.name
                        )}
                    </Feature>
                );
            })}
    </ul>
);

export const FeatureList = styled(BaseFeatureList)`
    margin-bottom: ${spacing.lg};

    @media (${breakpoints.mediumMin}) {
        padding-right: 40px;
        margin-bottom: 0;
    }
`;
